import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { I18nTranslatePipe } from '@gruposaltaedu/liv-i18n/core';

import { UiModule } from '../../../ui/ui.module';

@Component({
  selector: 'liv-app-loading-shell',
  imports: [I18nTranslatePipe, UiModule],
  templateUrl: './app-loading-shell.component.html',
  styleUrl: './app-loading-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppLoadingShellComponent {
  readonly titleKey = input('loading.title');
  readonly messageKey = input('loading.message');
  readonly currentYear = new Date().getFullYear();
}
